module.exports = __webpack_public_path__ + "static/Juxtapose-Sound-Jam-25cdedda2bcd942683e229c7815575b0.png";